import RejectionStatusCd from 'domain/enums/RejectionStatusCd';
import RejectionTypeCd from 'domain/enums/RejectionTypeCd';
import { Application } from 'domain/types/Application';

function hasRejected(
  applications: Application[] | null,
  typeCd: RejectionTypeCd
) {
  if (!applications || applications.length <= 0) {
    return false;
  }
  return applications.some((a) =>
    a.rejectionReasons.some(
      (r) =>
        r.statusCd === RejectionStatusCd.NOT_RESOLVED && r.typeCd === typeCd
    )
  );
}

export function isRejected(application: Application, typeCd: RejectionTypeCd) {
  return application.rejectionReasons.some(
    (r) => r.statusCd === RejectionStatusCd.NOT_RESOLVED && r.typeCd === typeCd
  );
}

export default hasRejected;
